import React, { ChangeEvent } from "react";
import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { isString, isValidInput } from "../utils/validations";

interface AddNotificationModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => void;
  title: string;
  setTitle: Dispatch<SetStateAction<string>>;
  message: string;
  setMessage: Dispatch<SetStateAction<string>>;
  error: boolean;
  setError: Dispatch<SetStateAction<boolean>>;
  setSelectedOptions: any;
  selectedOptions: any;
  checked: boolean;
  setChecked: Dispatch<SetStateAction<boolean>>;
}

export default function AddNotification({
  open,
  onClose,
  setOpen,
  title,
  setTitle,
  message,
  setMessage,
  error,
  setError,
  setSelectedOptions,
  checked,
  selectedOptions,
  setChecked,
  handleSubmit,
}: AddNotificationModalProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const options = [
    { value: 3, label: "Individuals" },
    { value: 4, label: "Wizard Team" },
    // { value: 5, label: "Freelancer Agents" },
    { value: 6, label: "B2B" },
  ];
  const label = { inputProps: { "aria-label": "controlled" } };
  const filteredOptions = options?.filter(
    (option) =>
      !selectedOptions?.some(
        (selected: { value: number }) => selected?.value === option?.value
      )
  );

  return (
    <Modal
      className="modal addNotification_modal"
      id="addNotificationModal"
      aria-labelledby="addNotification-modal-title"
      aria-describedby="addNotification-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Add Notification</h2>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Notification Title"
                fullWidth
                hiddenLabel
                inputProps={{ maxLength: 40 }}
                value={title}
                onChange={(e) => {
                  if (
                    isValidInput(e.target.value) &&
                    isString(e.target.value)
                  ) {
                    setTitle(e.target.value);
                  }
                }}
              />
              {error && title === "" ? (
                <h6 className="err_msg">Title is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Notification Message"
                fullWidth
                hiddenLabel
                multiline
                minRows={2}
                maxRows={3}
                inputProps={{ maxLength: 100 }}
                value={message}
                onChange={(e) => {
                  if (
                    isValidInput(e.target.value) &&
                    isString(e.target.value)
                  ) {
                    setMessage(e.target.value);
                  }
                }}
              />
              {error && message === "" ? (
                <h6 className="err_msg">Message is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="control_group">
              <Autocomplete
                className="users_autocomplete"
                disabled={checked}
                options={filteredOptions}
                multiple
                filterSelectedOptions
                disableCloseOnSelect
                onChange={(event, value) => {
                  setSelectedOptions(value);
                }}
                renderInput={(params: any) => (
                  <TextField fullWidth placeholder="Send to" {...params} />
                )}
              />
            </div>

            <div className="control_group">
              <FormControlLabel
                control={
                  <Checkbox
                    {...label}
                    checked={checked}
                    onChange={handleChange}
                  />
                }
                label="Send to All"
              />
            </div>
            <div className="footer_btn_flex">
              <Button
                className="btn btn_highlight"
                onClick={() => {
                  setError(false);
                  setTitle("");
                  setMessage("");
                  setSelectedOptions([]);
                  setChecked(false);
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_secondary"
                onClick={() => {
                  handleSubmit();
                  setError(true);
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
